// Copyright Epic Games, Inc. All Rights Reserved.

import { getSupportedLocale } from "./negotiation-strategy/supported-locale";

export type SupportedLocale =
  | "de-DE"
  | "en-US"
  | "es-ES"
  | "es-MX"
  | "fr-FR"
  | "it-IT"
  | "ja-JP"
  | "ko-KR"
  | "pl-PL"
  | "pt-BR"
  | "ru-RU"
  | "tr-TU"
  | "zh-CN"
  | "zh-TW"
  | "ar"
  | "da"
  | "fi"
  | "nl"
  | "no"
  | "sv"
  | "th";

const supportedLocales: SupportedLocale[] = [
  "de-DE",
  "en-US",
  "es-ES",
  "es-MX",
  "fr-FR",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "pl-PL",
  "pt-BR",
  "ru-RU",
  "tr-TU",
  "zh-CN",
  "zh-TW",
  "ar",
  "da",
  "fi",
  "nl",
  "no",
  "sv",
  "th",
];

/**
 * @desc Will check whether the language is supported, then will check whether
 * the language is supported, and if not will fallback to en-US locale.
 * @return supported locale
 */
export const getLocale = (): SupportedLocale => {
  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  // Direct match of user's language with supported locales
  if (supportedLocales.includes(locale)) {
    return locale;
  }

  // Use upscale strategy to match best locale; if failed fallback to default locale
  return getSupportedLocale(locale, supportedLocales, "en-US");
};
